import React from "react";
import {
  TextField,
  Grid,
  FormControlLabel,
  Switch,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { Field } from "formik";
import { i18n } from "../../translate/i18n";

/**
 * Seccion de credenciales / identidad de la conexion (name, token, status, isDefault).
 * SOLO para providers no-oficiales (Baileys / Evolution). La conexion oficial de Meta
 * (WABA) tiene su propio modal dedicado (WhatsAppOficialModal), ver 0362 §10.
 */
const ProviderCredentialsSection = ({ classes, values }) => {
  return (
    <>
                      {/* Nombre + Token en la misma fila */}
                      <Grid item xs={12} sm={6}>
                        <Field name="name">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label={i18n.t("whatsappModal.form.name")}
                              autoFocus
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              required
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              onChange={field.onChange}
                              InputProps={{
                                style: { fontSize: '0.875rem', height: '40px' }
                              }}
                              InputLabelProps={{
                                style: { fontSize: '0.875rem' }
                              }}
                              FormHelperTextProps={{
                                style: { fontSize: '0.75rem', marginTop: '4px' }
                              }}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field name="token">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Token (Opcional)"
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              className={classes.textFieldCompact}
                              value={field.value || ''}
                              onChange={field.onChange}
                              onBlur={field.onBlur}
                            />
                          )}
                        </Field>
                      </Grid>

                      {/* Status + Por defecto en la misma fila */}
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" margin="dense" fullWidth className={classes.formControlCompact}>
                          <InputLabel style={{ fontSize: '0.875rem' }}>Status</InputLabel>
                          <Field
                            as={Select}
                            name="status"
                            label="Status"
                            required
                          >
                            <MenuItem value="OPENING" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Abriendo</MenuItem>
                            <MenuItem value="CONNECTED" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Conectado</MenuItem>
                            <MenuItem value="DISCONNECTED" style={{ fontSize: '0.875rem', minHeight: '36px', padding: '6px 12px' }}>Desconectado</MenuItem>
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="isDefault"
                              checked={values.isDefault}
                            />
                          }
                          label={i18n.t("whatsappModal.form.default")}
                        />
                      </Grid>
    </>
  );
};

export default ProviderCredentialsSection;
